import { GridContainer, NoData, Span } from "@common";
import { Loader, SearchContent, TablePagination } from "@components";
import { Button } from "antd";
import { FaPlus } from "@icons";
import { useEffect, useMemo, useState } from "react";

import { COLUMNS } from "./Table/columns";
import { Dispatch, RootState } from "@store";
import { useDispatch, useSelector } from "react-redux";
import { PromoAdd } from "./Add/PromoAdd";
import { PromoEdit } from "./Edit/PromoEdit";

export const PromotionPage = () => {
  const column = useMemo(() => COLUMNS, []);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<Dispatch>();
  const tableName = "promo";

  const [searchData, setSearchData] = useState({
    filter: "keyword",
    value: "",
  });

  const [openModal, setOpenModal] = useState<boolean>(false);

  const { promoCode, promoModal } = useSelector((state: RootState) => state.UI);

  const promoData = useSelector(
    (state: RootState) => state.Table.tables.promo.data
  );

  const userAccess = useSelector(
    (state: RootState) => state.User.userInfo?.role_name?.access_group_id
  );

  const getPromoData = async () => {
    try {
      setIsLoading(true);
      dispatch.Table.getPromoList({
        table: tableName,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch.UI.updateState({ promoCode: "", promoModal: false });
    dispatch.Table.updateKeyword({ table: tableName, value: "" });
    getPromoData();
  }, []);

  const setFilters = () => {
    setIsLoading(true);
    const keyvalue =
      searchData?.value === ""
        ? ""
        : `&${searchData?.filter}=${searchData?.value}`;
    dispatch.Table.updateKeyword({ table: tableName, value: keyvalue });
    dispatch.Table.updatePageIndex({
      table: tableName,
      value: 1,
    });
    setIsLoading(false);
    getPromoData();
  };

  useEffect(() => {
    dispatch.Table.updatePageIndex({
      table: tableName,
      value: 1,
    });
    setSearchData({ filter: "keyword", value: "" });
  }, []);

  const searchOptions = [
    {
      value: "keyword",
      label: "Keyword",
    },
    {
      value: "title",
      label: "Title",
    },
    {
      value: "promo_code",
      label: "Promo Code",
    },
    {
      value: "is_active",
      label: "Status",
    },
  ];

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="main">
        <GridContainer grid="two">
          <Span weight="bold" size="2xl">
            Promotions Configuration
          </Span>

          <div className="search-bar">
            <SearchContent
              searchOptions={searchOptions}
              setFilters={setFilters}
              setSearchData={setSearchData}
              searchData={searchData}
            />
            {userAccess?.promotion_add && (
              <Button
                onClick={() => {
                  setOpenModal(true);
                }}
                type="primary"
                size="large"
              >
                <div className="flex pr-2 items-center">
                  <FaPlus className="my-auto mx-2 text-md items-center inline-flex" />
                  Add
                </div>
              </Button>
            )}
          </div>
        </GridContainer>

        {promoData?.length > 0 ? (
          <TablePagination
            columns={column}
            data={promoData}
            dataType={tableName}
          />
        ) : (
          <NoData />
        )}

        {/* Add */}
        <PromoAdd
          openModal={openModal}
          setOpenModal={setOpenModal}
          getData={getPromoData}
        />

        {/* Edit */}
        {promoCode && (
          <PromoEdit
            getData={getPromoData}
            table={tableName}
            promoCode={promoCode}
            promoModal={promoModal}
            setIsLoading={setIsLoading}
          />
        )}
      </div>
    </>
  );
};
